exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sort-span[data-v-4c69d4c8]{\n    color:#000000;\n}\n", ""]);

// exports
